"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var LinkTheme = function LinkTheme(colors) {
  return {
    defaultProps: {
      variant: 'subtitle2'
    },
    styleOverrides: {
      root: {
        textDecorationColor: 'inherit',
        '&:hover': {
          color: colors.hover,
          textDecoration: 'none'
        },
        '&:active': {
          color: colors.click,
          textDecoration: 'none'
        }
      },
      underlineHover: {
        textDecoration: 'underline',
        '&:hover': {
          textDecoration: 'none'
        }
      }
    },
    variants: [{
      props: {
        color: 'disabled'
      },
      style: {
        textDecoration: 'none',
        cursor: 'default',
        '&:hover': {
          color: colors.grey30
        },
        '&:active': {
          color: colors.grey30
        }
      }
    }]
  };
};

var _default = LinkTheme;
exports["default"] = _default;